import React, { ChangeEvent, FunctionComponent } from "react";
import { connect, MapStateToProps, MergeProps } from "react-redux";

import { createQA } from "@multiweb/reactUtils";
import { IAppState, QAProps } from "@multiweb/types/react";
import { isWorkflowReadOnly } from "../../../selectors";
import { WorkflowEditorProps } from "../../../types";
import { getEditableControlClassName } from "./utils";

type EditComponentProps = {
    readonly value: string | number;
    readonly pattern?: string;
    readonly maxLength?: number;
    readonly type?: "text" | "number";
    readonly placeholder?: string;
    readonly readOnly?: boolean;
    readonly required?: boolean;
    readonly onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
} & QAProps;

const EditComponent: FunctionComponent<EditComponentProps> = ({ value = "", maxLength, placeholder, pattern, type = "text", readOnly = false, required = false, qa, onChange }) => (
    <div {...createQA(qa)} className={getEditableControlClassName(required, readOnly)}>
        <input autoComplete="off" {...{ value, readOnly, maxLength, placeholder, pattern, type, onChange }} />
    </div>
);

type EditProps = EditComponentProps & WorkflowEditorProps;

type StateProps = {
    readonly isWorkflowReadonly: boolean;
};

const mapStateToProps: MapStateToProps<StateProps, EditProps, IAppState> = (state, { hostKey }) => ({
    isWorkflowReadonly: isWorkflowReadOnly(state, hostKey),
});

const mergeProps: MergeProps<StateProps, undefined, EditProps, EditComponentProps> = ({ isWorkflowReadonly }, _dispatychProps, ownProps) => ({
    ...ownProps,
    readOnly: isWorkflowReadonly || ownProps.readOnly,
});

export const Edit = connect(mapStateToProps, undefined, mergeProps)(EditComponent);
